import Card from "components/Card/Card";
import { Checkbox, MultiSelect } from "components/inputs";
import ControlledSelect from "components/inputs/Select/ControlledSelect";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import type { ClientType } from "types/DataTypes";
import { useSelector } from "utils/redux";

const GeneralClientSettings = ({
  client,
  onSave,
}: {
  client: ClientType;
  onSave: (field: string, value: unknown) => Promise<void>;
}) => {
  const { register, reset, control, getValues } = useForm({
    defaultValues: {
      type: "",
      trigger_lien_investigation: false,
      attach_consent_to_release_to_intake_ack: false,
      services: [],
    },
  });
  const constants = useSelector((state) => state.shared.constants);

  useEffect(() => {
    reset({
      type: client?.type,
      trigger_lien_investigation: client?.trigger_lien_investigation,
      attach_consent_to_release_to_intake_ack:
        client?.attach_consent_to_release_to_intake_ack,
      services: [],
    });
  }, [client, reset]);

  return (
    <Card heading="General Client Settings">
      <ControlledSelect
        control={control}
        name="type"
        errors={null}
        label="Type"
        onSave={(o) => onSave("type", o?.value)}
        options={constants?.CLIENT_TYPES || []}
      />
      <Controller
        control={control}
        name="services"
        render={({ field: { onChange: onControllerChange, value } }) => (
          <MultiSelect
            label="Lines of Insurance"
            name="services"
            options={constants?.PLAN_INSURANCE_TYPE || []}
            value={value}
            onChange={(selectedOptions) => {
              onControllerChange(selectedOptions);
              onSave("services", selectedOptions);
            }}
          />
        )}
      />
      <Checkbox
        {...register("trigger_lien_investigation", {
          onChange: () =>
            onSave(
              "trigger_lien_investigation",
              getValues("trigger_lien_investigation"),
            ),
        })}
        label="Trigger Lien Investigation"
      />
      <Checkbox
        {...register("attach_consent_to_release_to_intake_ack", {
          onChange: () =>
            onSave(
              "attach_consent_to_release_to_intake_ack",
              getValues("attach_consent_to_release_to_intake_ack"),
            ),
        })}
        label="Attach Consent to Release to Intake Acknowledgement"
      />
    </Card>
  );
};

export default GeneralClientSettings;
